import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LicenseApiService {

  constructor(private http: HttpClient) {}

  readonly licenseUrl: string = 'license/key';
  readonly machineIdUrl: string = 'license/machineId';

  public getLicense(): Observable<any> {

    return this.http.get(this.licenseUrl).pipe(map((license: any) => {
      if (license.features) {
        license.features = license.features.sort(this.sortFeatures);
      }
      return license;
    }));
  }

  public editLicense(license): Observable<any> {
    return this.http.put(this.licenseUrl, license);
  }

  public getMachineId(): Observable<any> {
    return this.http.get(this.machineIdUrl);
  }

  private sortFeatures(featureA, featureB) {
    return featureA.ordinal - featureB.ordinal;
  }
}
